require("./src/styles/syntax/tomorrow.css")
export function onServiceWorkerUpdateReady(){window.location.reload(true)}